import i18n from "dev/lang";

function $t(key) {
	return i18n.t(key);
}

export default {
  default: "surveyor",

  routes: {
    admin: {
      routes: [
        {title: $t("attributes.users"), name: "users-page", icon: "fas fa-users"},
        {title: $t("pages.orderFilter.survyers"), name: "surveyors-page", icon: "fas fa-pencil-ruler"},
        {title: $t("attributes.userCustomers"), name: "officers-page", icon: "fas fa-user-tie"},
        {title: $t("pages.clientsView.title"), name: "client-page", icon: "mdi-factory"},
        {
          title: $t("attributes.orders") + "  " + $t("pages.measurementForm.measurement"),
          name: "orders-page",
          icon: "fas fa-weight-hanging"
        },
        {title: $t("attributes.projects"), name: "projects-page", icon: "mdi-account-hard-hat"},
        {title: $t("attributes.reports"), "name": "reports-page", icon: "fas fa-file-excel"},
        {title: "ניהול ערים", "name": "cities-page", icon: "fas fa-city"},
        {title: "ניהול אזורים", "name": "areas-page", icon: "mdi-format-list-bulleted"},
        {title: $t("attributes.helpVideo"), name: "help-page", icon: "fas fa-chalkboard-teacher"}
      ]
    },
    surveyor: {
      routes: [
        {title: $t("attributes.orders") + "  "+ $t("pages.measurementForm.measurement"), name: "orders-page", icon: "fa-weight-hanging"},
        {title: $t("attributes.helpVideo"),name:"help-page", icon:"fas fa-chalkboard-teacher"},
      ]
    },
    client: {
      routes: [
        {title: $t("attributes.users"), name: "officers-page", icon: "fas fa-user-tie"},
        {title: $t("attributes.orders") + "  "+ $t("pages.measurementForm.measurement"), name: "orders-page", icon: "fa-weight-hanging"},
        {title: $t("attributes.projects"), name: "projects-page", icon: "mdi-account-hard-hat"},
        {title: $t("attributes.reports"), "name": "reports-page", icon: "fas fa-file-excel"},
        {title: $t("attributes.helpVideo"),name:"help-page", icon:"fas fa-chalkboard-teacher"}
      ]
    }
  }
};
